import { notificationInstance } from '@/shared/api/api-instances/notification/api-instance';
import type {
  PageSettingsSchema,
  SettingResponse,
  SettingsRequest,
} from '../model/types';
import type { AxiosRequestConfig } from 'axios';

export class NotificationSettingsApi {
  static getAllSettings(params = {}, options: AxiosRequestConfig = {}) {
    return notificationInstance.get<PageSettingsSchema>(`/settings`, {
      ...options,
      params,
    });
  }

  static getSettingById(setting_id: string, options: AxiosRequestConfig = {}) {
    return notificationInstance.get<SettingResponse>(
      `/settings/${setting_id}`,
      options,
    );
  }

  static editSetting(
    setting_id: string,
    payload: SettingsRequest,
    options: AxiosRequestConfig = {},
  ) {
    return notificationInstance.put<SettingResponse>(
      `/settings/${setting_id}`,
      payload,
      options,
    );
  }
}